import userAction from '@stores/user/action';

/**
 * 全局封装的 ensureLogin 方法
 * 兼容 userAction 上的不同命名（onEnsureLogin / ensureLogin / checkLogin）
 * @param {Function} callback - 登录后执行的回调函数
 */
export const ensureLogin = (callback: () => void): boolean | void => {
    if (userAction && typeof userAction.onEnsureLogin === 'function') {
        return userAction.onEnsureLogin(callback);
    }
    if (userAction && 'ensureLogin' in userAction && typeof (userAction as any).ensureLogin === 'function') {
        return (userAction as any).ensureLogin(callback);
    }
    if (userAction && 'checkLogin' in userAction && typeof (userAction as any).checkLogin === 'function') {
        if ((userAction as any).checkLogin()) {
            if (typeof callback === 'function') callback();
            return true;
        }
        return false;
    }
    if (typeof callback === 'function') callback();
    return true;
};